module.exports = __webpack_public_path__ + "media/images/sp/stores/tachikawa/tachikawa_sns_02-584701c90b0f8a0555155e01893186de.jpg";